import api from "./api";

// Normalize backend product → component-shaped product (camelCase + slug as id)
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function absUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  if (u.startsWith("/api/uploads/")) return `${BACKEND}${u}`;
  return u;
}

export function normalizeProduct(doc) {
  if (!doc) return null;
  const cleanImages = (Array.isArray(doc.images) ? doc.images : [])
    .filter((s) => typeof s === "string" && s.trim().length > 0)
    .map(absUrl);
  return {
    id: doc.slug || doc.id,
    uuid: doc.id,
    slug: doc.slug,
    name: doc.name,
    price: doc.price,
    originalPrice: doc.original_price ?? null,
    category: doc.category,
    color: doc.color,
    colorHex: doc.color_hex,
    fabric: doc.fabric,
    description: doc.description,
    badge: doc.badge || null,
    images: cleanImages.length ? cleanImages : ["/hero/1.jpg"],
    sizes: Array.isArray(doc.sizes) && doc.sizes.length
      ? doc.sizes
      : ["XS", "S", "M", "L", "XL"],
    stock: doc.stock || {},
    rating: doc.rating ?? 4.8,
    reviews: doc.reviews ?? 0,
    active: doc.active !== false,
  };
}

export function normalizeCategory(doc) {
  return {
    id: doc.slug,
    name: doc.name,
    caption: doc.caption || "",
    image: absUrl(doc.image || ""),
  };
}

export async function fetchProducts(params = {}) {
  const { data } = await api.get("/products", { params });
  return (data || []).map(normalizeProduct);
}

export async function fetchProductBySlug(slug) {
  const { data } = await api.get(`/products/${slug}`);
  return normalizeProduct(data);
}

export async function fetchCategories() {
  const { data } = await api.get("/categories");
  return (data || []).map(normalizeCategory);
}

// Build a unique colour palette from the product list
export function deriveColors(products) {
  const seen = new Map();
  for (const p of products) {
    if (p.color && !seen.has(p.color)) {
      seen.set(p.color, { name: p.color, hex: p.colorHex || "#E2B4BD" });
    }
  }
  return Array.from(seen.values());
}
